import { render } from "./navModal.vue?vue&type=template&id=aaad7472"
import script from "./navModal.vue?vue&type=script&lang=js"
export * from "./navModal.vue?vue&type=script&lang=js"

import "./navModal.vue?vue&type=style&index=0&id=aaad7472&lang=css"

import exportComponent from "/Users/Tomi/Documents/Projects/web3sptkDC/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__